import type {
  ShouldRestorePushNotificationsProps,
  UseRestorePushNotificationsProps,
} from "@/hooks/useRestorePushNotifications/types";

const shouldRestorePushNotifications = (
  _unused: ShouldRestorePushNotificationsProps,
) => false;

const useRestorePushNotifications = (
  _unused: UseRestorePushNotificationsProps,
) => null;

export { shouldRestorePushNotifications, useRestorePushNotifications };
